import BSCEntities from "@/utils/constants/BSCEntities.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import ConstantViewNames from "@/utils/constants/ConstantViewNames.ts";

export default class EntityViewCustomizer
{
  static getHiddenQuestionsInListView(entityType: string, listViewName: string) {
    if (entityType === BSCEntities.ApprovalDefinition && ObjectChecker.isAnyEqualToFirst(listViewName, ConstantViewNames.EMPLOYEE_APPROVALS_SCREEN_NAME,
      ConstantViewNames.EMPLOYEE_READ_NOTIFICATIONS_SCREEN_NAME))
      return ["employee", "userId"];
    return [];
  }
}
